// jshint esversion: 8
export default d => {
  try {
    const yr = d.getFullYear();
    const mo = d.getMonth() >= 9 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`;
    const day = d.getDate() >= 10 ? d.getDate() : `0${d.getDate()}`;
    return `${yr}-${mo}-${day}`;
  } catch (e) {
    if (typeof d.getFullYear != 'function') {
      throw new Error('Provided argument must be a date object');
    }
  }
};
